import {Card, Descriptions} from "antd";
import React from "react";

const ShipmentDetail = ({shipmentInfo}) => {
    console.log(shipmentInfo);
    return (
        <>
            <Card title="Paket Bilgileri" bordered>
                <Descriptions bordered column={2}>
                    <Descriptions.Item label="Paket Numarası">
                        {shipmentInfo?.shipmentNumber || "-"}
                    </Descriptions.Item>

                    <Descriptions.Item label="Müşteri Adı">
                        {shipmentInfo?.receiverName || "-"}
                    </Descriptions.Item>

                    <Descriptions.Item label="İl">{shipmentInfo?.city || "-"}</Descriptions.Item>

                    <Descriptions.Item label="İlçe">
                        {shipmentInfo?.district || "-"}
                    </Descriptions.Item>
                    <Descriptions.Item label="Paket Sayısı">
                        {shipmentInfo?.count + " Paket" || "-"}
                    </Descriptions.Item>
                    <Descriptions.Item label="Depo">
                        {shipmentInfo?.transferCenter || "-"}
                    </Descriptions.Item>
                </Descriptions>
            </Card>
        </>
    );
};

export default ShipmentDetail;
